var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPowerPoint64 = function SvgPowerPoint64(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "PowerPoint_64_svg__b",
    x1: 5.56,
    x2: 26.44,
    y1: 13.917,
    y2: 50.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ca4c28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#c5401e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b62f14"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "PowerPoint_64_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    x: 7,
    y: 4,
    fill: "none",
    rx: 27.73
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ed6c47",
    d: "M34.735 4A27.816 27.816 0 0 0 7 31.734V32l34 4-6-32Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff8f6b",
    d: "M63 32v-.266A27.816 27.816 0 0 0 35.265 4H35v28l13 6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#d35230",
    d: "M63 32a28 28 0 0 1-56 0Z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#PowerPoint_64_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h64v64H0z",
    opacity: 0.75,
    style: {
      mixBlendMode: "soft-light"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h64v64H0z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.379 16H11.934A27.6 27.6 0 0 0 8 24.39v15.22A27.8 27.8 0 0 0 14.331 51h16.048a2.606 2.606 0 0 0 2.576-2.179 2 2 0 0 0 .045-.452V18.631A2.62 2.62 0 0 0 30.379 16",
    opacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.278 15h-17.62A27.7 27.7 0 0 0 8 24.39v15.22A27.7 27.7 0 0 0 13.455 50h16.823a3.69 3.69 0 0 0 2.56-1.05A3.74 3.74 0 0 0 34 46.24V18.76A3.754 3.754 0 0 0 30.278 15",
    opacity: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.379 16H11.934A27.6 27.6 0 0 0 8 24.39v15.22A27.7 27.7 0 0 0 12.658 49h17.721A2.63 2.63 0 0 0 33 46.349v-27.7A2.63 2.63 0 0 0 30.379 16",
    opacity: 0.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.359 16H11.934A27.6 27.6 0 0 0 8 24.39v15.22A27.7 27.7 0 0 0 12.658 49h16.7A2.64 2.64 0 0 0 32 46.349v-27.7A2.64 2.64 0 0 0 29.359 16",
    opacity: 0.1
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    y: 16,
    fill: "url(#PowerPoint_64_svg__b)",
    rx: 2.667
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.241 23.334a6.87 6.87 0 0 1 4.627 1.39 5.03 5.03 0 0 1 1.606 4.025 5.7 5.7 0 0 1-.794 3.009 5.36 5.36 0 0 1-2.258 2.049 7.5 7.5 0 0 1-3.393.731h-3.21v6.129H9.526V23.334Zm-3.422 8.557h2.834a3.62 3.62 0 0 0 2.505-.767 2.87 2.87 0 0 0 .847-2.242q0-2.865-3.246-2.865h-2.94Z"
  }))));
};
export default SvgPowerPoint64;